require('./datadog-setup');

window.Clarity = require('@microsoft/clarity').default;

import 'font-awesome/scss/font-awesome.scss';

require('animate.css');
require('country-flags');
require('ui-select/dist/select.min.css');
require('ng-sortable/dist/ng-sortable.min.css');
require('ng-sortable/dist/ng-sortable.style.css');
require('angular-tablesort/tablesort.css');
require('angularjs-toaster/toaster.scss');
require('typicons.font');
require('angularjs-color-picker/dist/angularjs-color-picker.min.css');

window.jsPlumb = require('jsplumb').jsPlumb;
require('@shopify/draggable/build/umd/index.js');
require('jquery');
require('angular');
require('angular-animate');
require('angular-cookies');
require('angular-elastic');
require('angular-loading-overlay');
require('angular-local-storage');
require('angularjs-audio');
require('angular-logger');
require('angular-payments');
require('angular-resource');
require('angular-sanitize');
require('angular-smart-table');
require('angular-tablesort');
require('angular-touch');
require('angular-translate');
require('@uirouter/angularjs');
require('angular-ui-bootstrap');
require('angularjs-toaster');
require('bootstrap-daterangepicker');
require('highcharts-ng');
require('intl-tel-input/build/js/utils.js');
require('intl-tel-input/build/js/intlTelInput-jquery.min.js');
require('lodash');
require('./scripts/shared/customised-plugins/lrDragNDrop');
require('moment');
require('moment-timezone');
require('ng-intl-tel-input');
require('ng-sortable');
require('sprintf-js');
require('sprintf-js/src/angular-sprintf');
require('ui-select');
require('ng-file-upload');
require('highcharts');
require('highcharts/modules/exporting')(Highcharts);
require('randomcolor');
require('angularjs-color-picker');
require('angular-feature-flags');

require('json2csv');
require('ua-parser-js');
